import * as React from 'react';
import { useSelector } from 'react-redux';

import CheckoutAdditionalServiceBase from '@websky/core/src/CheckoutAdditionalService';
import { getBaggagePrice } from '@websky/core/src/Checkout/store/orderPrice/selectors';
import { getAnimalServices, getTravellers } from '@websky/core/src/Checkout/store/order/selectors';
import { useAnimalService } from '@websky/core/src/CheckoutAdditionalService/components/hooks';
import { AdditionalServiceType } from '@websky/core/src/CheckoutAdditionalService/types';

const CheckoutAdditionalService: React.FC<React.ComponentProps<typeof CheckoutAdditionalServiceBase>> = props => {
	const isBaggage = props.serviceType === AdditionalServiceType.Baggage;
	const travellers = useSelector(getTravellers);

	const baggagePrice = useSelector(getBaggagePrice);

	const animalServices = useSelector(getAnimalServices);
	const { totalPrice: animalTotalPrice } = useAnimalService(animalServices, travellers);

	const priceTotal = React.useMemo(() => {
		if (isBaggage) {
			let price = { ...baggagePrice };

			if (animalTotalPrice.amount > 0 && price.amount >= animalTotalPrice.amount) {
				price = {
					...price,
					amount: price.amount - animalTotalPrice.amount
				};
			}

			if (price.amount > 0) {
				return price;
			}

			return null;
		}

		return props.priceTotal;
	}, [isBaggage, baggagePrice, animalTotalPrice, props.priceTotal]);

	return <CheckoutAdditionalServiceBase {...props} priceTotal={priceTotal} />;
};

export default CheckoutAdditionalService;
